function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import merge from 'lodash/merge';
export function isString(s) {
  return Object.prototype.toString.call(s) === '[object String]';
}
export function isObject(s) {
  return Object.prototype.toString.call(s) === '[object Object]';
}
export function isArray(s) {
  return Object.prototype.toString.call(s) === '[object Array]';
}
export function isNumber(s) {
  return Object.prototype.toString.call(s) === '[object Number]';
}
function isFunction(s) {
  return Object.prototype.toString.call(s) === '[object Function]';
}
export function evaluateBuilder(builder) {
  if (builder instanceof Promise) {
    return builder.then(function (r) {
      return evaluateBuilder(r);
    });
  }
  if (isArray(builder)) {
    return Promise.all(builder.map(evaluateBuilder));
  }
  if (isFunction(builder)) {
    return evaluateBuilder(Promise.resolve(builder()));
  }
  if (isObject(builder)) {
    var keys = Object.getOwnPropertyNames(builder);
    var results = keys.reduce(function (accl, key) {
      var node = builder[key];
      if (isObject(node) || isFunction(node) || node instanceof Promise) {
        return accl.concat(evaluateBuilder(node));
      }
      return accl.concat([new Promise(function (r) {
        return r(node);
      })]);
    }, []);
    return Promise.all(results).then(function (resolvedResults) {
      return resolvedResults.reduce(function (accl, res, index) {
        return merge(accl, _defineProperty({}, keys[index], res));
      }, {});
    });
  }
  return new Promise(function (r) {
    return r(builder);
  });
}
export function evaluateAndFlatten(builder) {
  if (isArray(builder)) {
    return Promise.all(builder.map(function (b) {
      return evaluateBuilder(b);
    })).then(function (results) {
      return merge.apply(void 0, [{}].concat(_toConsumableArray(results.filter(isObject))));
    });
  }
  return evaluateBuilder(builder);
}

/**
 * Function for getting device type taken from the old SDK. It performs as well
 * as one could expect from the size. It could be replaced with 'ua-parser-js'
 * at the cost of 11kb minimized.
 *
 * @param {string} userAgent
 *
 * @returns {string} the device type the user is using
 */
export function deviceType(userAgent) {
  var knownDevices = {
    mobile: ['iPhone;', 'iPod;', 'iPod touch;', '^HTC', 'Fennec', 'IEMobile', 'BB10;', 'BlackBerry', 'SymbianOS.*AppleWebKit', '^Mozilla.*Mobile.*Firefox', '^Mozilla.*Chrome.*Mobile', 'Opera Mobi', 'Android.*Mobile', 'Android.*Mini', 'Symbian', '^SonyEricsson', '^Nokia', '^SAMSUNG', '^LG'],
    tablet: ['iPad;', 'Android']
  };
  function isDeviceIn(object) {
    var regex;
    for (var i = 0; i < object.length; i += 1) {
      regex = object[i];
      if (userAgent.match(new RegExp(regex))) {
        return true;
      }
    }
    return false;
  }
  if (userAgent) {
    if (isDeviceIn(knownDevices.mobile)) {
      return 'mobile';
    }
    if (isDeviceIn(knownDevices.tablet)) {
      return 'tablet';
    }
  }
  return 'desktop';
}
export function dateTime() {
  return new Date().toISOString();
}